import { put, all, takeLatest } from 'redux-saga/effects';
import { createSlice } from '@reduxjs/toolkit';
import { fetchReducerActions, createFetchAction, createSaga, fetchInitialState } from 'store/utils';
import * as invoiceApi from 'api/invoice';

export const fetch_invoice_summary_init = createFetchAction('fetch_invoice_summary_init');
export const fetch_invoice_summary = createFetchAction('fetch_invoice_summary');
export const fetch_invoice_total_init = createFetchAction('fetch_invoice_total_init');
export const fetch_invoices = createFetchAction('fetch_invoices');
export const fetch_invoice = createFetchAction('fetch_invoice');
export const create_invoice = createFetchAction('create_invoice');
export const fetch_project_invoice = createFetchAction('fetch_project_invoice');
export const create_project_summary = createFetchAction('create_project_summary');
export const edit_project_summary = createFetchAction('edit_project_summary');
export const delete_invoice = createFetchAction('delete_invoice');

interface InitialState {
  invoiceSummaryInit: object | any;
  invoiceSummary: object | any;
  invoiceTotalInit: object | any;
  invoices: object | any;
  invoice: object | any;
  createInvoice: object | any;
  projectInvoice: object | any;
  createSummary: object | any;
  editSummary: object | any;
  deleteInvoice: object | any;
}

const initialState: InitialState = {
  invoiceSummaryInit: { ...fetchInitialState, data: null },
  invoiceSummary: { ...fetchInitialState, data: null },
  invoiceTotalInit: { ...fetchInitialState, data: null },
  invoices: { ...fetchInitialState, data: null },
  invoice: { ...fetchInitialState, data: null },
  createInvoice: { ...fetchInitialState, data: null },
  projectInvoice: { ...fetchInitialState, data: null },
  createSummary: { ...fetchInitialState, data: null },
  editSummary: { ...fetchInitialState, data: null },
  deleteInvoice: { ...fetchInitialState, data: null },
};

const slice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    ...fetchReducerActions(fetch_invoice_summary_init, 'invoiceSummaryInit'),
    ...fetchReducerActions(fetch_invoice_summary, 'invoiceSummary'),
    ...fetchReducerActions(fetch_invoice_total_init, 'invoiceTotalInit'),
    ...fetchReducerActions(fetch_invoices, 'invoices'),
    ...fetchReducerActions(fetch_invoice, 'invoice'),
    ...fetchReducerActions(create_invoice, 'createInvoice'),
    ...fetchReducerActions(fetch_project_invoice, 'projectInvoice'),
    ...fetchReducerActions(create_project_summary, 'createSummary'),
    ...fetchReducerActions(edit_project_summary, 'editSummary'),
    ...fetchReducerActions(delete_invoice, 'deleteInvoice'),
  },
});

export const actions: any = slice.actions;

export function* invoiceSaga() {
  yield all([
    takeLatest(
      actions.fetch_invoice_summary_init_request,
      createSaga(actions, 'fetch_invoice_summary_init', invoiceApi.fetchSummaryInvoiceInit),
    ),
    takeLatest(
      actions.fetch_invoice_summary_request,
      createSaga(actions, 'fetch_invoice_summary', invoiceApi.fetchInvoiceSummary),
    ),
    takeLatest(
      actions.fetch_invoice_total_init_request,
      createSaga(actions, 'fetch_invoice_total_init', invoiceApi.fetchTotalInvoiceInit),
    ),
    takeLatest(
      actions.fetch_invoices_request,
      createSaga(actions, 'fetch_invoices', invoiceApi.fetchInvoices),
    ),
    takeLatest(
      actions.fetch_invoice_request,
      createSaga(actions, 'fetch_invoice', invoiceApi.fetchInvoice),
    ),
    takeLatest(
      actions.create_invoice_request,
      createSaga(actions, 'create_invoice', invoiceApi.createInvoice),
    ),
    takeLatest(
      actions.fetch_project_invoice_request,
      createSaga(actions, 'fetch_project_invoice', invoiceApi.fetchProjectInvoice),
    ),
    takeLatest(
      actions.create_project_summary_request,
      createSaga(actions, 'create_project_summary', invoiceApi.createProjectSummary),
    ),
    takeLatest(
      actions.edit_project_summary_request,
      createSaga(actions, 'edit_project_summary', invoiceApi.editProjectSummary),
    ),
    takeLatest(
      actions.delete_invoice_request,
      createSaga(actions, 'delete_invoice', invoiceApi.delteInvoice),
    ),
  ]);
}

export default slice.reducer;
